import type { AIModelChoices } from 'api';

export const AI_MODEL_LABEL_MAP: Record<AIModelChoices, string> = {
  alu: 'Bale',
  alu_loose: 'Loose',
  briquette: 'Briquette',
  hdpe: 'Bale',
  other: 'Other',
  pet: 'Bale',
  pet_dummy_bale: 'Bale',
  pet_dummy_bale_2: 'Bale',
  pet_envases: 'Bale',
  pet_loose: 'Loose',
};
